<template>
    <div class="download">
        <div class="banner">
            <div class="banner-content">
                <div class="left">
                <div v-for="(item,index) in bannerList" :key="index"  :class="item.cls ? item.cls : ''">
                    <span class="main-title" v-if="item.title == '正式版'">云题库及网络版客户端：</span>
                    <span class="sub-title">{{item.title}}</span>
                    <div @click="download(index)">下载地址</div>
                </div>
                <div><span>网页版题库</span><div @click="toTiku">立即试用</div></div>
                <div><span>在线考试：PC端</span><div @click="toExam">立即试用</div></div>
                <div>
                    <el-tooltip class="item" effect="dark" content="微信搜索小程序“乐考试”" placement="right-start">
                        <span>在线考试：微信小程序</span>
                    </el-tooltip>
                </div>
                <div>
                    <el-tooltip class="item" effect="dark" content="微信搜索小程序“乐分享组卷”" placement="right-start">
                        <span>微信小程序在线组卷</span>
                    </el-tooltip>
                </div>
                </div>
            </div>
        </div>
        <div class="one">
            <div>我们的软件-<span>下载</span></div>
            <div>企业产品是生产经营活动的劳动成果</div>
            <div class="swiper-content" v-if="0">
                <!-- <el-carousel arrow="always" :autoplay="false" type="card" height="379px">
                <el-carousel-item v-for="item in 6" :key="item">
                    <div class="icon">
                        <img :src="diannao" alt="">
                    </div>
                    <div class="title">软件下载</div>
                    <div class="intro">让每一位用户都有良好的体验让每一位用户都有良好的体验</div>
                </el-carousel-item>
                </el-carousel> -->
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="item in 4" :key="item">
                            <div class="icon">
                                <img :src="diannao" alt="">
                            </div>
                            <div class="title">软件下载</div>
                            <div class="intro">让每一位用户都有良好的体验让每一位用户都有良好的体验</div>
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination"></div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="common first">
            <div class="item">
                <div class="content">
                    <div>
                        <img :src="one" alt="">
                    </div>
                    <div>Word批量<span style="color:#cc4507">超级</span>大师  1.2.1.6</div>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/BatchWord_Super.zip'">点击下载</a><br/>
                        <a class="el-button--danger" href="#1">总计有27大类，几百个小功能</a>
                        <a class="el-button--danger" href="#1">强烈推荐！！！</a>
                        <a class="el-button--success" href="#1">基础型：无数量限制，包括11个常用基础功能</a>
                        <a class="el-button--info" href="#1">全能体验型：有数量限制，每次最多处理50个，每天最多处理500个</a>
                        <a class="el-button--success" href="#1">旗舰型：可以使用所有功能，无数量限制</a>
                        <a class="el-button--success" href="#1">自选功能型：无数量限制，可以只购买27大类中的任意一个或者多个 ，需要哪个功能就购买哪个功能，不需要的功能可以不买</a>
                        <a class="moren" href="#1">安装即用，效率极高，极其稳定！！！</a>
                        <a class="moren" href="#1">一键保存设置，后续直接导入使用！</a> 
                        <a class="moren" href="#1">无人值守式操作：设置好之后，一键自动处理，无需人工值守，几十万份文件自动处理完成！！！</a>
                        <a class="moren" href="#1">在任意一台电脑都可以凭账号密码登录使用！！！（一个账号同一时间最多一台电脑使用）</a>
                        <a class="moren" href="#1">速度极快：速度实测是《Word文档批量处理大师》软件处理速度的10~50倍！！！</a>
                    </div>
                </div>
                <div class="icon"></div>
            </div>
        </div>

       
        <div class="common first">
            <div class="item">
                <div class="content">
                    <div>
                        <!-- <img :src="one" alt=""> -->
                    </div>
                    <div style="color:dimgrey">Word文档批量处理大师   9.0.8</div>
                    <div class="btn">
                        <a class="el-button--danger" href="#1">强烈推荐使用第一个软件: Word批量超级大师！！！</a><br/>
                        <a class="el-button--warning" :href="path + './soft/BatchWord.rar'">点击下载</a><br/>
                        <a class="el-button--danger" target="_blank" href="https://wellsoft.taobao.com/category-1332381929.htm?spm=2013.1.w4010-1995377314.8.959eebe3Tgwgb&search=y&parentCatId=385482048&parentCatName=office%C5%FA%C1%BF%B4%A6%C0%ED%B4%F3%CA%A6&catName=Word%CE%C4%B5%B5%C5%FA%C1%BF%B4%A6%C0%ED%B4%F3%CA%A6#bd">购买</a><br/>
                        <a class="el-button--success" :href=" path + './help/BatchWord_Help.rar'">图文教程</a>
                        <a class="el-button--info" target="_blank" href="http://v.youku.com/v_show/id_XNzgxNDIyMjg4.html?f=22843018">视频教程</a><br/>
                        <a class="moren" href="javascript:;" @click="toPay">付款方式</a><br/>
                        <a class="moren" href="javascript:;" @click="toDan">单机版注册</a>
                        <a class="moren" href="javascript:;" @click="toU">U盘版注册</a>
                    </div>
                </div>
                <!-- <div class="icon"></div> -->
            </div>
        </div>

        
        <div class="common two">
            <div class="item">
                <div class="icon"></div>
                <div class="content">
                    <div>
                        <img :src="two" alt="">
                    </div>
                    <div>PPT批量处理大师   6.0.6</div>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/BatchPPT.rar'">点击下载</a><br/>
                        <a class="el-button--danger" href="https://wellsoft.taobao.com/category-1332381930.htm?spm=a1z10.5-c.w4010-1995377319.9.bd8268fxOsDoH&search=y&parentCatId=385482048&parentCatName=office%C5%FA%C1%BF%B4%A6%C0%ED%B4%F3%CA%A6&catName=PPT%C5%FA%C1%BF%B4%A6%C0%ED%B4%F3%CA%A6#bd" target="_blank">购买</a><br/>
                        <a class="el-button--success" :href="path + './help/BatchPPT_Help.rar'">图文教程</a>
                        <a class="el-button--info" href="http://v.youku.com/v_show/id_XNzgxNDIyMjg4.html?f=22843018" target="_blank">视频教程</a><br/>
                        <a class="moren" href="javascript:;" @click="toPay">付款方式</a><br>
                        <a class="moren" href="javascript:;" @click="toDan">单机版注册</a>
                        <a class="moren" href="javascript:;" @click="toU">U盘版注册</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="common three">
            <div class="item">
                <div class="content">
                    <div>
                        <img :src="three" alt="">
                    </div>
                    <div>轻松教学题库系统   个人版   12.2.128    超级极速豪华版</div>
                    <div style="color:;font-size:16px;line-height:40px;">1、既支持Word也支持WPS，符合99%以上用户的常用习惯！
                        <br>2、对Word（WPS）格式数学（物理、化学）题目中的公式、符号完全兼容，都可以批量导入题库，并且入库前是公式，重新组卷后仍然是公式，不会变为图片！！！
                        <br>3、题目中的图片、图形都会跟随题目批量导入，无需单独导入，特别方便！！！
                        <br>4、一份几百题的试卷可以一键智能识别快速批量入库（只需要符合极少的格式规范）！
                        <br>5、除了支持单选、多选、判断、填空、解答等题型外，更支持复杂题型的题目的批量入库，如：英语中的阅读理解、完型填空；地理、医学题中的组合题等… …
                        <br>6、章节、知识点、题型等都可以自定义！最新版支持自定义标签功能！
                        <br>7、欢迎联系我们定制开发您自己需要的特殊功能！
                    </div>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Personal.rar'">点击下载</a><br/>
                        <a class="el-button--danger" href="https://wellsoft.taobao.com/" target="_blank">购买</a><br>
                        <a class="el-button--success" target="_blank" href="https://pan.baidu.com/s/1BJr2HyNvJ1j-3zSPoz0oSg">图文教程</a>提取码：qalk<br>
                        <a class="el-button--info" href="https://pan.baidu.com/s/1BJr2HyNvJ1j-3zSPoz0oSg" target="_blank">视频教程</a>提取码：qalk<br>
                        <a class="moren" href="javascript:;" @click="toPay">付款方式</a><br>
                        <a class="moren" href="javascript:;" @click="toPersonDan">单机版注册</a>
                        <a class="moren" href="javascript:;" @click="toPersonU">U盘版注册</a><br>
                    </div>
                </div>
                <div class="icon"></div>
            </div>
        </div>
        <div class="common six">
            <div class="item">
                <div class="icon"></div>
                <div class="content">
                    <div>
                        <h1>4</h1>
                    </div>
                    <div>乐分享题库系统 · 网络客户端版·<span style="color:#F88927;">正式版</span></div>
                    <div style="color:;font-size:16px;line-height:40px;">1、既支持Word也支持WPS，符合99%以上用户的常用习惯！
                        <br>2、对Word（WPS）格式数学（物理、化学）题目中的公式、符号完全兼容，都可以批量导入题库，并且入库前是公式，重新组卷后仍然是公式，不会变为图片！！！
                        <br>3、题目中的图片、图形都会跟随题目批量导入，无需单独导入，特别方便！！！
                        <br>4、一份几百题的试卷可以一键智能识别快速批量入库（只需要符合极少的格式规范）！
                        <br>5、除了支持单选、多选、判断、填空、解答等题型外，更支持复杂题型的题目的批量入库，如：英语中的阅读理解、完型填空；地理、医学题中的组合题等… …
                        <br>6、章节、知识点、题型等都可以自定义！最新版支持自定义标签功能！
                        <br>7、网络版和网页版、云题库都支持多人协作在线实时共享！多人多科目快速自建特色题库！！！
                    </div>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Net.rar'">点击下载</a><br/>
                        <a class="el-button--danger" href="https://wellsoft.taobao.com/" target="_blank">购买</a><br/>
                        <a class="el-button--success" target="_blank" href="http://www.lefunsoft.com/help/index.html">图文教程</a>
                        <a class="el-button--info" href="https://pan.baidu.com/s/1qaSFrpgb-1OP4x1-G9AHOg" target="_blank">视频教程</a>提取码：37g7<br>
                        <a class="moren" href="javascript:;" @click="toPay">付款方式</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="common try">
            <div class="item">
                
                <div class="content">
                    <div>
                        <h1>5</h1>
                    </div>
                    <div>乐分享题库系统 · 网络客户端版·<span style="color:#F88927;">试用版</span></div>
                    <div style="color:;font-size:16px;line-height:40px;">1、既支持Word也支持WPS，符合99%以上用户的常用习惯！
                        <br>2、对Word（WPS）格式数学（物理、化学）题目中的公式、符号完全兼容，都可以批量导入题库，并且入库前是公式，重新组卷后仍然是公式，不会变为图片！！！
                        <br>3、题目中的图片、图形都会跟随题目批量导入，无需单独导入，特别方便！！！
                        <br>4、一份几百题的试卷可以一键智能识别快速批量入库（只需要符合极少的格式规范）！
                        <br>5、除了支持单选、多选、判断、填空、解答等题型外，更支持复杂题型的题目的批量入库，如：英语中的阅读理解、完型填空；地理、医学题中的组合题等… …
                        <br>6、章节、知识点、题型等都可以自定义！最新版支持自定义标签功能！
                        <br>7、网络版和网页版、云题库都支持多人协作在线实时共享！多人多科目快速自建特色题库！！！
                        <br>8、欢迎联系我们定制开发您自己需要的特殊功能！
                    </div>
                    <div class="btn">
                        <a class="el-button--warning" :href="path + './soft/LFX_ExercLib_Net_Test.rar'">点击下载</a><br/>
                        <a class="el-button--danger" href="https://wellsoft.taobao.com/" target="_blank">购买</a><br/>
                        <a class="el-button--success" target="_blank" href="http://www.lefunsoft.com/help/index.html">图文教程</a>
                        <a class="el-button--info" href="https://pan.baidu.com/s/1qaSFrpgb-1OP4x1-G9AHOg" target="_blank">视频教程</a>提取码：37g7<br>
                        <a class="moren" href="javascript:;" @click="toPay">付款方式</a>
                    </div>
                </div>
                <div class="icon"></div>
            </div>
        </div>
        <div class="common four">
            <div class="item">
                <div class="icon"></div>
                <div class="content">
                    <div>
                        <h1>6</h1>
                    </div>
                    <div>完整版Office下载</div>
                    <div>为了解决用户电脑上安装的是精简版office导致软件不能正常运行，找习惯用的完整版office一时找不到的情况，特提供几个常用微软Office完整版的下载地址。注册和激活需要自己解决。</div>
                    <div class="btn">
                        <a class="el-button--info" href="http://pan.baidu.com/s/1c1xT6gC" target="_blank">1、微软 Office 2010 完整版</a><br>
                        <a class="el-button--info" href="http://pan.baidu.com/s/1kUur1kj" target="_blank">2、微软 Office 2013 完整版</a><br>
                        <a class="el-button--info" href="http://pan.baidu.com/s/1i5qiNx7" target="_blank">3、微软 Office 2016 完整版</a>
                    </div>
                    <div><a href="javascript:;" @click="toMsdn">注：快速找到需要的完整版Office</a></div>
                </div>
                
            </div>
        </div>
        <div class="common five">
            <div class="item">
                
                <div class="content">
                    <div>
                        <h1>7</h1>
                    </div>
                    <div>免费题库资源</div>
                    <div class="btn">
                        <a class="el-button--warning" href="javascript:;" @click="toDown">点击下载</a>
                    </div>
                </div>
                <div class="icon"></div>
            </div>
        </div>
        <div class="bottom" v-if="0">
            <el-carousel indicator-position="outside" :interval="5000" arrow="always" height="434px">
                <el-carousel-item v-for="item in 4" :key="item">
                    <div>
                        <img :src="bottom" alt="">
                    </div>
                    <div class="title">乐分享软件开发</div>
                    <div class="intro">乐分享软件开发乐分享软件开发乐分享软件开发乐分享软件开发乐分享软件开发</div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min.js'
export default {
    data(){
        return {
            diannao: require('@/assets/icon_e@2x.png'),
            one: require('@/assets/img_1@2x.png'),
            two: require('@/assets/img_2@2x.png'),
            three: require('@/assets/img_3@2x.png'),
            bottom: require('@/assets/img_rjkf@2x.png'),
            path: process.env.BASE_URL,
            bannerList: [
                {
                    title: 'Word批量超级大师（强烈推荐）'
                },
                {
                    title: 'Word文档批量处理大师'
                },
                {
                    title: 'PPT批量处理大师'
                },
                {
                    title: '轻松教学题库系统 个人版'
                },
                {
                    title: '正式版',
                    cls: 'small',
                },
                {
                    title: '试用版',
                    cls: 'small',
                }
            ]
        }
    },
    created(){
        
    },
    mounted(){
        new Swiper('.swiper-container', {
            slidesPerView: 3,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    },
    methods: {
        toTiku(){
            window.open(IPConfig.tikuUrl);
        },
        toExam(){
            window.open(IPConfig.examUrl);
        },
        download(index){
            document.querySelectorAll('.download .common')[index].scrollIntoView({
                behavior: 'smooth'
            })
        },
        toPersonU(){
            this.$router.push({
                name: 'PersonalU'
            })
        },
        toPersonDan(){
            this.$router.push({
                name: 'PersonalDan'
            })
        },
        toMsdn(){
            var a = this.$router.resolve({name: 'NewsMsdn'});
            window.open(a.href);
        },
        toDan(){
            var a = this.$router.resolve({name: 'Computer'});
            window.open(a.href);
        },
        toU(){
            var a = this.$router.resolve({name: 'Udisk'});
            window.open(a.href);
        },
        toPay(){
            var a = this.$router.resolve({name: 'Pay'});
            window.open(a.href);
        },
        toDown(){
            var a = this.$router.resolve({name: 'Free'});
            window.open(a.href);
        }
    }
}
</script>
<style lang="less">
    .download{
        .banner{
            height: 730px;
            background: #198AF7 url('../assets/img_rjxz@2x.png') no-repeat center center;
            background-size: auto 100%;
            .banner-content{
                width: 1200px;
                position: relative;
                margin: 0 auto;
                height: 100%;
                .left{
                    position: absolute;
                    top: 120px;
                    right: 20px;
                    color: #fff;
                    >div{
                        margin-bottom: 16px;
                        font-size: 24px;
                        span{
                            // color: #FFA95E;
                            vertical-align: middle;
                        }
                        .main-title{
                            display: block;
                            margin-bottom: 10px;
                        }
                        div{
                            float: right;
                            text-align: center;
                            vertical-align: middle;
                            font-size: 16px;
                            // width:120px;
                            height:30px;
                            padding: 0 10px;
                            line-height: 30px;
                            white-space: nowrap;
                            margin-top: 4px;
                            border:1px solid rgba(255,255,255,1);
                            border-radius:15px;
                            margin-left: 10px;
                            cursor: pointer;
                            &:hover{
                                background-color: #f88927;
                                border-color: #f88927;
                            }
                        }
                    }
                    .small{
                        .sub-title{
                            display: inline-block;
                            margin-left: 179px;
                        }
                        div{
                            margin-left: 0;
                        }
                    }
                }
            }
        }
        .one{
            text-align: center;
            padding: 30px;
            >div{
                &:nth-of-type(1){
                    font-size: 36px;
                    background: url('../assets/download.png') no-repeat center center;
                    background-size: 375px 45px;
                    background-position-y: 0px;
                    line-height: 80px;
                    span{
                        color: #F88927;
                    }
                }
                &:nth-of-type(2){
                    color: #8F8F8F;
                    font-size: 20px;
                }
            }
            .swiper-content{
                position: relative;
                width: 1200px;
                margin: 0 auto;
                .swiper-button-prev,.swiper-button-next{
                    &:focus{
                    outline: none;
                    }
                }
                .swiper-container{
                    width: 1100px;
                    padding: 60px 30px;
                    .swiper-slide{
                        text-align: center;
                        padding: 20px;
                        padding-bottom: 30px;
                        padding-top: 59px;
                        background: #fff;
                        box-sizing: border-box;
                        height: 362px;
                        border-radius:4px;
                        cursor: pointer;
                        &:hover{
                            border: 1px solid #32AEFB;
                            transition: all 0.6s;
                            transform: scale(1.04);
                            box-shadow:0px 5px 10px 0px rgba(24,165,235,0.36);
                        }
                        .el-rate{
                            text-align: left;
                            margin-bottom: 40px;
                            margin-left: 30px;
                            .el-icon-star-on:before{
                                font-size: 24px;
                            }
                        }
                        .title{
                            color: #F88927;
                            font-size: 30px;
                            margin: 50px 0 20px 0;
                        }
                        .intro{
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .common{
            background-color: #49BDEE;
            .el-button--primary{
                background-color: #409EFF;
            }
            .el-button--success{
                background-color: #67C23A;
            }
            .el-button--info{
                background-color: #909399;
            }
            .el-button--danger{
                background-color: #F56C6C;
            }
            .item{
                width: 1200px;
                margin: 0 auto;
                box-sizing: border-box;
                padding: 70px;
                // height: 464px;
                display: flex;
                .content{
                    flex: 1;
                    >div{
                        &:nth-of-type(1){
                            font-size: 40px;
                            color: #F88927;
                        }
                        &:nth-of-type(2){
                            font-size: 36px;
                            margin-top: 20px;
                        }
                        &:nth-of-type(3){
                            font-size: 20px;
                            color: #fff;
                            margin: 40px 0;
                        }
                    }
                    
                    .btn{
                        a{
                            border-radius: 20px;
                            padding: 12px 23px;
                            display: inline-block;
                            text-decoration: none;
                            color: #fff;
                            margin-right: 10px;
                            margin-bottom: 20px;
                            &:hover{
                                opacity: 0.7;
                            }
                        }
                        .moren{
                            background-color: #409eff;
                        }
                    }
                }
                .icon{
                    flex: 1;
                    background: url('../assets/download/word.png') no-repeat center center;
                }
            }
        }
        .first{
            .icon{
                background-size: 410px 350px!important;
            }
        }
        .two{
            background-color: #fff;
            .content{
                padding-left: 60px;
                >div{
                    &:nth-of-type(3){
                        color: #8F8F8F!important;
                    }
                }
            }
            .icon{
                background: url('../assets/download/ppt.png') no-repeat center center!important;
                background-size: 450px 400px!important;
            }
        }
        .three{
            .icon{
                background: url('../assets/download/personal.png') no-repeat center center!important;
                background-size: 450px 400px!important;
            }
            .item{
                padding-bottom: 0;
            }
        }
        .four{
            background: #fff;
            .icon{
                background: url('../assets/icon_rj2@2x.png') no-repeat center center!important;
            }
            
        }
        .six{
            background: #fff;
            .icon{
                background: url('../assets/download/net.png') no-repeat center center!important;
                background-size: 450px 400px!important;
            }
            .item{
                padding-bottom: 0;
            }
            .content{
                >div{
                    &:nth-of-type(3){
                        color: #8F8F8F!important;
                    }
                }
            }
        }
        .try{
            .icon{
                background: url('../assets/download/net.png') no-repeat center center!important;
                background-size: 450px 400px!important;
            }
            
        }
        .five{
            margin-bottom: 20px;
            .icon{
                background: url('../assets/icon_rj3@2x.png') no-repeat center center!important;
            }
            .content{
                >div{
                    &:nth-of-type(3){
                        color: #8F8F8F!important;
                    }
                }
            }
        }
        .bottom{
            padding: 100px 0;
            .el-carousel{
                width: 1200px;
                margin: 0 auto;
                .el-carousel__item{
                    text-align: center;
                    padding: 20px;
                    padding-top: 50px;
                    background: #fff;
                    box-sizing: border-box;
                    border: 1px solid rgba(24,165,235,0.36);
                    .title{
                        font-size: 24px;
                        margin-top: 50px;
                        margin-bottom: 20px;
                    }
                    .intro{
                        margin: 0 auto;
                        width: 536px;
                        color: #8F8F8F;
                        font-size: 18px;
                    }
                }
            }
        }
    }
</style>